import { render, staticRenderFns } from "./AppTranslationInput.vue?vue&type=template&id=612e0866&scoped=true&"
import script from "./AppTranslationInput.vue?vue&type=script&lang=js&"
export * from "./AppTranslationInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "612e0866",
  null
  
)

export default component.exports